import { useSelector } from "react-redux";
import { AppStore } from "../store";
import { ContentCardState } from "../types/content-card";

export const useGetContentCards = () => {
  return useSelector<AppStore, ContentCardState>(
    (store) => store.contentCardState
  );
};
